module.exports = __webpack_public_path__ + "bg.c43902aa.svg";